import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const StyledPaper = styled(Paper)`
  padding: 10px 20px;
  display: flex;
  align-items: flex-end;
  @media (max-width: 520px) {
    width: 100%;
    &:not(:last-of-type) {
      margin-bottom: 30px;
    }
  }
  & > div:first-of-type {
    flex-grow: 2;
  }
`;

export const CardTitle = styled.h3`
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: darkGrey;
  margin: 0 0 10px 0;
  line-height: unset;
`;

export const CardValue = styled.p`
  margin: 0;
  font-size: 1.6rem;
`;

export const CardIcon = styled.div`
  display: flex;
  align-items: center;
`;
